// TooltipSpan_v02.tsx
// Version: v02a

import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface TooltipSpanProps {
  text: React.ReactNode;
  tooltip: React.ReactNode;
  placement?: "top" | "bottom" | "left" | "right";
}

const TooltipSpan_v02a = ({
  text,
  tooltip,
  placement = "top",
}: TooltipSpanProps) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip id="tooltip-span">{tooltip}</Tooltip>}
    >
      <span style={{ cursor: "pointer" }}>
        {text}
      </span>
    </OverlayTrigger>
  );
};

export default TooltipSpan_v02a;

/*
File: TooltipSpan_v02.tsx
Description: React-Bootstrap tooltip using span
Version: v02a
*/